import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { useQuery } from "@redux-requests/react";
import { Formik } from "formik";
import _ from "lodash";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Loader } from "../../components";
import { SubmitButton } from "../../components/formik";
import { types } from "../../ducks";
import { getEPoster, getProfiles, getTags, updateEposter } from "../../ducks/actions";
import { useActionRequest } from "../../hooks";
import EposterForm from "./EposterForm";

const EditEposterDialog = ({ id, onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTags({ resource: "eposters" }));
    dispatch(getProfiles({ role: "accademic" }));
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(getEPoster({ id }));
    }
  }, [dispatch, id]);

  const {
    data: { data: eposter },
    loading: eposterLoading
  } = useQuery({ type: types.GET_EPOSTER, defaultData: { data: {} } });

  const updateEposterRequest = useActionRequest({
    action: updateEposter
  });

  const authors = _.filter(eposter.eposterAccademics, { category: "author" }).map(
    ({ id, profile }) => ({
      value: profile?.id,
      label: `${profile?.firstName} ${profile?.lastName}`,
      id
    })
  );

  const coAuthors = _.filter(eposter.eposterAccademics, { category: "co_author" }).map(
    ({ id, profile }) => ({
      value: profile?.id,
      label: `${profile?.firstName} ${profile?.lastName}`,
      id
    })
  );
  const selectedTags =
    eposter.tagList === undefined
      ? []
      : eposter.tagList.map(name => ({
          label: name,
          value: name
        }));
  const onAddNewEposter = async value => {
    const newAuthors = _.differenceBy(value.authors, authors, "value").map(({ value }) => ({
      category: "author",
      profileId: value
    }));
    const toDeleteAuthors = _.differenceBy(authors, value.authors, "value").map(({ id }) => ({
      id,
      _destroy: true
    }));
    const newCoAuthors = _.differenceBy(value.coAuthors, coAuthors, "value").map(({ value }) => ({
      category: "co_author",
      profileId: value
    }));
    const toDeleteCoAuthors = _.differenceBy(coAuthors, value.coAuthors, "value").map(({ id }) => ({
      id,
      _destroy: true
    }));
    updateEposterRequest({
      id: eposter.id,
      eposter: {
        ...value,
        eposterAccademicsAttributes: [
          ...newAuthors,
          ...toDeleteAuthors,
          ...newCoAuthors,
          ...toDeleteCoAuthors
        ],
        tag_list: value.tags.map(({ value }) => value).toString()
      }
    });
    onClose();
  };

  const initialValues = {
    tags: selectedTags,
    document: null,
    title: "",
    subTitle: "",
    description: "",
    videoUrl1: "",
    videoUrl2: "",
    videoUrl3: "",
    ...eposter,
    authors,
    coAuthors
  };

  return (
    <Loader loading={eposterLoading}>
      <Formik onSubmit={onAddNewEposter} initialValues={initialValues}>
        <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
          <DialogContent>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h5" noWrap>
                {intl.formatMessage({
                  id: "Eposters.EditEposterDialog.EditEPoster",
                  defaultMessage: "Edit E-Poster"
                })}
              </Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
            <EposterForm />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>
              {intl.formatMessage({
                id: "Eposters.EditEposterDialog.Close",
                defaultMessage: "Close"
              })}
            </Button>
            <SubmitButton onClick={onClose} variant="contained" color="primary" size="small">
              {intl.formatMessage({
                id: "Eposters.EditEposterDialog.Save",
                defaultMessage: "Save"
              })}
            </SubmitButton>
          </DialogActions>
        </Dialog>
      </Formik>
    </Loader>
  );
};

export default EditEposterDialog;
